import React from 'react';

interface EmailLinkProps {
  email: string;
}

const EmailLink: React.FC<EmailLinkProps> = ({ email }) => (
    <a 
      href={`mailto:${email}`} 
      className="text-primary hover:text-primary/80 underline transition-colors"
    >
      {email}
    </a>
  );

export default EmailLink;